import { Button, Flex, Form, Input, Modal, notification, Switch } from 'antd'
import React, { useEffect, useRef, useState } from 'react'
import { useForm } from 'antd/es/form/Form'
import { editRelative, IRelativeEdit } from '../../../../api/customerRelative/customerRelativeApi'

interface Props {
  show: boolean
  infoCustomerRelative?: IRelativeEdit
  modalClose?: () => void
  onSubmitModalEdit: (isSucces: boolean, errorMessage?: string) => void
}

const EditRelativeModal: React.FC<Props> = (props) => {
  const { show, infoCustomerRelative, modalClose, onSubmitModalEdit } = props
  const [isStatus, setIsStatus] = useState(false)
  const formRef: any = useRef(null)
  const [form] = useForm()

  const onFormFinish = async (value: any) => {
    const { name, code } = value
    const result = await editRelative(Number(infoCustomerRelative?.id), code, name, Number(isStatus))
    if (result.status) {
      onSubmitModalEdit?.(true, result.message)
    } else {
      onSubmitModalEdit?.(false, result.message)
    }
  }

  useEffect(() => {
    if (show && infoCustomerRelative) {
      form.setFieldValue('name', infoCustomerRelative?.title)
      form.setFieldValue('code', infoCustomerRelative?.code)

      setIsStatus(!!infoCustomerRelative?.status)
    } else {
      setIsStatus(false)
    }
  }, [show, infoCustomerRelative])



  return (
    <>
      <Modal
        open={show}
        title='Chỉnh sửa mối quan hệ'
        className='rs-modal w-400 footer-content-end add-relative-modal'
        centered
        footer={
          <Button
            type='primary'
            className='rs-button rs-button--sm'
            onClick={() => formRef?.current.submit()}
          >Lưu</Button>
        }
        onCancel={modalClose}
      >
        <Form
          form={form}
          ref={formRef}
          className='rs-form add-relative-form'
          onFinish={onFormFinish}
          requiredMark={false}
        >
          <Form.Item
            layout='vertical'
            label='Mã mối quan hệ'
            name='code'
            rules={[
              { required: true, message: "Vui lòng nhập Mã mối quan hệ" }
            ]}
          >
            <Input
              maxLength={8}
              placeholder='Mã mối quan hệ'
              className='rs-input rs-input--32'
            />
          </Form.Item>
          <Form.Item
            layout='vertical'
            label='Tên mối quan hệ'
            name='name'
            rules={[
              { required: true, message: "Vui lòng nhập Tên mối quan hệ" }
            ]}
          >
            <Input
              placeholder='Tên mối quan hệ'
              className='rs-input rs-input--32'
            />
          </Form.Item>

          <Form.Item name='status'>
            <Flex className='gap-24px'>
              <span>Sử dụng</span>
              <Switch
                checked={isStatus}
                onChange={() => setIsStatus(!isStatus)}
                className="rs-switch"
              />
            </Flex>
          </Form.Item>
        </Form>
      </Modal>
    </>
  )
}

export default EditRelativeModal
